export interface NotificationsUnreadCount {
    unreadCount: number;
}
